import { isFunction } from "lodash-es"
import qs from "query-string"
import { useNavigate, useLocation } from "react-router-dom"

function useSearchParams<T = any>() {
  // Types
  type ValueAsFunction = (params: T) => T
  const location = useLocation()
  const navigate = useNavigate()
  const search = qs.parse(location.search, {
    arrayFormat: "comma",
  }) as unknown as T

  function handleChange(value: T | ValueAsFunction) {
    navigate({
      pathname: location.pathname,
      search: qs.stringify(isFunction(value) ? value(search) : value, {
        arrayFormat: "comma",
      }),
    })
  }
  return [search, handleChange] as const
}

export default useSearchParams
